import { e as n, i as b, t as o } from "./directive-C5OgdAy2.js";
class h extends b {
  constructor(e) {
    if (super(e), this.observing = !1, this.tabindex = -1, e.type !== o.ATTRIBUTE || e.name !== "tabindex")
      throw new Error(
        "The `scrollableRegion` directive must be used in the `tabindex` attribute"
      );
    this.part = e, this.resizeObserver = this.setupResizeObserver();
  }
  setupResizeObserver() {
    if (!this.resizeObserver)
      return new ResizeObserver((r) => {
        for (const s of r) {
          const {
            target: { scrollHeight: t, clientHeight: i }
          } = s;
          this.tabindex = Number(t) > Number(i) ? 0 : -1, this.render();
        }
      });
  }
  render() {
    this.part && this.part.name === "tabindex" && (this.part.element.tabIndex = this.tabindex);
  }
  update(e) {
    this.resizeObserver && !this.observing && this.resizeObserver.observe(e.element);
  }
}
const c = n(h);
export {
  c as s
};
